import React from 'react';
export default function WarningFilled(_a) {
    var className = _a.className;
    return (React.createElement("svg", { className: className, width: "1em", height: "1em", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 -960 960 960" },
        React.createElement("path", { xmlns: "http://www.w3.org/2000/svg", d: "m40-120 440-760 440 760zm444.18-117q12.82 0 21.32-8.68 8.5-8.67 8.5-21.5 0-12.82-8.68-21.32-8.67-8.5-21.5-8.5-12.82 0-21.32 8.68-8.5 8.67-8.5 21.5 0 12.82 8.68 21.32 8.67 8.5 21.5 8.5M454-348h60v-224h-60z" })));
}
